import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	AppendixFourDTO,
	AppendixFourRequest,
	AppendixFourSaveDTO,
} from '../DTO/forms-management/appendix4';

export const appendix4 = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAppendix4List: builder.query<SuccessResponse<AppendixFourDTO[]>, string>(
			{
				query: (id) => ({
					url: `/web/form/appendix-four/list/${id}`,
					method: 'GET',
				}),
				providesTags: ['Appendix4List'],
			}
		),
		deleteAppendix4: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/appendix-four/${id}`,
				method: 'DELETE',
			}),

			invalidatesTags: ['Appendix4List'],
		}),
		appendix4HasDraft: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/appendix-four/has-draft/${id}`,
				method: 'GET',
			}),
			keepUnusedDataFor: 0,
		}),
		getAppendix4Draft: builder.query<
			SuccessResponse<AppendixFourSaveDTO>,
			{ id: string; type: string }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/appendix-four/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		continueAppendix4Draft: builder.mutation<
			SuccessResponse<AppendixFourSaveDTO>,
			{ id: string; type: number }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/appendix-four/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		editAppendix4: builder.mutation<SuccessResponse<any>, AppendixFourRequest>({
			query: (body) => ({
				url: `/web/form/appendix-four/${body.id}`,
				method: 'PUT',
				body,
			}),
		}),
		createAppendix4: builder.mutation<
			SuccessResponse<any>,
			AppendixFourRequest
		>({
			query: (body) => ({
				url: `/web/form/appendix-four`,
				method: 'POST',
				body,
			}),
		}),
		getAppendix4Detail: builder.query<SuccessResponse<AppendixFourDTO>, string>(
			{
				query: (id) => ({
					url: `/web/form/appendix-four/${id}`,
					method: 'GET',
				}),
			}
		),
	}),
});

export const {
	useGetAppendix4ListQuery,
	useDeleteAppendix4Mutation,
	useAppendix4HasDraftQuery,
	useGetAppendix4DraftQuery,
	useContinueAppendix4DraftMutation,
	useEditAppendix4Mutation,
	useCreateAppendix4Mutation,
	useGetAppendix4DetailQuery,
} = appendix4;
